// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"1b80075b","437":"ab2461b9","454":"d66f71e5","572":"fc891236"}[chunkId] + ".chunk.js";
};